import React from "react";
import "./ProgressBar.css";

function ProgressBar({ currentStep = 1 }) {
  const steps = [
    "Mobile Verification",
    "Personal Details",
    "Document Upload",
    "Nominee Details",
    "Review Application",
    "Payment & Membership ID",
  ];

  const safeCurrentStep = Math.min(
    Math.max(Number(currentStep) || 1, 1),
    steps.length
  );

  const progressPercentage =
    steps.length > 1
      ? ((safeCurrentStep - 1) / (steps.length - 1)) * 100
      : 0;

  return (
    <div className="progress-wrapper">

      {/* Progress line */}
      <div className="progress-line">
        <div
          className="progress-line-active"
          style={{
            width: `${progressPercentage}%`,
          }}
        />
      </div>

      {/* Steps */}
      <div className="progress-steps">
        {steps.map((step, index) => {
          const stepNumber = index + 1;

          let stepClass = "";

          if (safeCurrentStep === stepNumber) {
            stepClass = "active";
          } else if (safeCurrentStep > stepNumber) {
            stepClass = "completed";
          }

          return (
            <div
              key={stepNumber}
              className={`progress-step ${stepClass}`}
            >
              <div
                className="step-circle"
                aria-current={
                  safeCurrentStep === stepNumber
                    ? "step"
                    : undefined
                }
              >
                {stepNumber}
              </div>

              <div className="step-label">
                {step}
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}

export default ProgressBar;